import { ReportFeatures } from '@hcs/types';

export const SUBJECT_COMMENT_FEATURES = [ReportFeatures.SubjectComment];
export const dataHcEventSectionSubjectComment = 'Comments';
export const SUBJECT_COMMENT_LAUNCHER_FEATURES = SUBJECT_COMMENT_FEATURES;
